import * as types from './types'
import { objArryDeepCopy } from '@/untils/util.js'

const CLIENT_ADD_FRIEND_DEFAULT_FORM_DATA = {
  wechatName: '',
  storeIds: [],
  allStores: 2,
  qrcodeUrl: '',
  tipLists: []
}

const state = {
  // 顾客加好友表单信息
  clientAddFriendFormData: objArryDeepCopy(CLIENT_ADD_FRIEND_DEFAULT_FORM_DATA)
}
const mutations = {
  /**
   * @author lwq
   * @function 设置顾客加好友信息
   * @param {Object} data
   * data 参数所有字段规范：
   *    qrcodeUrl         {String} 微信二维码
   *    wechatName        {String} 微信名称
   *    tags              {List<String>} 标签列表
   *    ways              {String} 途径集合：PAY 支付后，POSTER 海报，TABLE 桌码，MINA_PROGRAM 小程序
   *    qrcodeId          {Number} 对应 qrcodeId
   *    storeIds          {List<String>}  门店id集合
   */
  [types.SET_CLIENT_ADD_FRIEND_FORM_DATA] (state, data) {
    state.clientAddFriendFormData = Object.assign(state.clientAddFriendFormData, data)
  },
  [types.EMPTY_CLIENT_ADD_FRIEND_FORM_DATA] (state) {
    state.clientAddFriendFormData = objArryDeepCopy(CLIENT_ADD_FRIEND_DEFAULT_FORM_DATA)
  }
}
export default {
  state,
  mutations
}
